/** Intervalo de atualização automática das consultas na home do profissional (minutos). */
export const PROFESSIONAL_HOME_SESSIONS_REFETCH_INTERVAL_MINUTES = 3;

export const PROFESSIONAL_HOME_SESSIONS_REFETCH_INTERVAL_MS =
	PROFESSIONAL_HOME_SESSIONS_REFETCH_INTERVAL_MINUTES * 60 * 1_000;
